import { guestVMsDto } from '../dto/guestVMsDto';
import { guestVMsViewModel } from '../views/guestVMsViewModel';

export class GuestVMsTableTransformer {
  public static from(guestVMs: guestVMsDto): guestVMsViewModel {
    return <guestVMsViewModel>{
      IsRunning: guestVMs.isRunning == null ? '-' : DisplayIsRunning(guestVMs.isRunning),
      VMName: guestVMs.name == null ? '-' : guestVMs.name,
      OS: guestVMs.os == null ? '-' : guestVMs.os,
      DiskCapacity:
        guestVMs.diskCapacity == null ? '-' : parseFloat((guestVMs.diskCapacity).toFixed(2)),
      DiskUsed: guestVMs.diskUsed == null ? '-' : parseFloat((guestVMs.diskUsed).toFixed(2)),
      DiskOccupancy:
        guestVMs.diskOccupancy == null ? '-' : parseFloat(guestVMs.diskOccupancy.toFixed(2)),
      UsedMemory:
        guestVMs.memoryUsed == null
          ? '-'
          : parseFloat((guestVMs.memoryUsed).toFixed(2)),
      ProvisionedMemory:
        guestVMs.memory == null
          ? '-'
          : parseFloat((guestVMs.memory).toFixed(2)),
      VirtualCPU: guestVMs.vcpu == null ? '-' : guestVMs.vcpu,
      Platform: guestVMs.platform == null ? '-' : guestVMs.platform
    };
    function DisplayIsRunning(isRunning: boolean) {
      return isRunning == true ? 'Yes' : 'No';
    }
  }
}
